module.exports = __webpack_public_path__ + "static/media/AeroCaptureInactive.97754e19.png";